import { useEffect } from 'react';
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

import { cn } from './cn';

export interface SkeletonProps {
  /** Size/shape utilities, e.g. "h-4 w-32 rounded-md". */
  className?: string;
}

const PULSE_DURATION_MS = 800;

/** A pulsing placeholder block for loading states; size via `className`. */
export function Skeleton({ className }: SkeletonProps) {
  // Opacity is animated, so it lives in an animated style, not a className.
  const opacity = useSharedValue(1);
  useEffect(() => {
    opacity.value = withRepeat(
      withTiming(0.4, { duration: PULSE_DURATION_MS, easing: Easing.inOut(Easing.ease) }),
      -1,
      true,
    );
  }, [opacity]);

  const pulseStyle = useAnimatedStyle(() => ({ opacity: opacity.value }));

  return <Animated.View className={cn('bg-well', className)} style={pulseStyle} />;
}
